import React from "react";

import { getFillPercent, getProgressText, getStrokeColor } from "./utils";
import { formatNumber } from "helpers/utility/formatters";
import ImageIcon from "assets/icons/imageIcon";
import CheckIcon from "assets/icons/CheckIcon";
import ProgressBase from "../ProgressBase";

import styles from "./style.module.scss";

interface EncourageProgressProps {
  value: number;
  min: number;
  text?: string;
  icon?: React.ReactNode;
}

export default function EncourageProgress({
  value,
  min = 20,
  text,
  icon,
}: EncourageProgressProps) {
  const MILESTONE_FILL_PERCENT = 15;
  const fillPercent = getFillPercent(value, min, MILESTONE_FILL_PERCENT);

  return (
    <div className={styles.container}>
      <div className={styles.progressHeader}>
        {icon ? (
          icon
        ) : (
          <span role="img" aria-label="default icon">
            <ImageIcon />
          </span>
        )}
        <span>{text || getProgressText(value, min)}</span>
      </div>
      <div className={styles.progressWrapper}>
        <ProgressBase
          strokeColor={getStrokeColor(value, min)}
          fillPercent={fillPercent}
        />
        {value > min && (
          <div
            className={styles.milestoneMarker}
            data-min-zero={min === 0}
            aria-label={min === 0 ? "milestone-min-zero" : undefined}
            data-testid="milestone-marker"
          >
            <div className={styles.circleIcon} data-testid="check-icon">
              <CheckIcon />
            </div>
          </div>
        )}

        <div className={styles.countCircle}>{formatNumber(value)}</div>
      </div>
    </div>
  );
}
